<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2022-10-29 17:07:32
 * @LastEditors: 诺
 * @LastEditTime: 2022-10-31 22:56:50
-->


<template>
  <div class="bg">
    <!-- 右侧导航 -->
    <BaseImg :option="{style: {'margin-top':'14px','margin-left':'16px',width: '71px','align-self': 'flex-start'},url: 'logo.png',}"/>
    <div class="bgImg"></div>
    
    <BaseImg :option="{style: {'margin':'27px auto 0',width: '100%',},url: 'slogan.png',}"/>

    <div class="pro-box" :class="`pro-box${chooseBuildList.length}`">
      <div class="pro-nav">
        <div class="nav" :class="{choose: chooseAddressIndex == index}" v-for="(item, index) in addressList" :key="index" @click="chooseAddress(item.infoId)">{{item.name}}</div>
      </div>
      <div class="welfare" v-for="(item, index) in chooseBuildList" :key="index + 'img'">
        <div class="project_title">{{item.name}}</div>
        <img class="prize" :src="`${imgHost}wlfare/prize.png?v=${$config.OSSVersion}`"/>
        <div class="welfare_item" v-for="(v, i) in item.welfare" :key="i + 'welfare'">
          <img class="name" :src="`${imgHost}wlfare/title${v.type}.png?v=${$config.OSSVersion}`"/>
          <div class="title" v-html="v.title"></div>
          <div class="info">{{v.info}}</div>
        </div>
      </div>
      
    </div>
    <div class="share act_animate_shake_seesaw_config">
      <img  :src="`${imgHost}wlfare/share_btn.png?v=${$config.OSSVersion}`"/>
      <div class="xcx">
        <wx-open-launch-weapp
          id="launch-btn"
          :username="'gh_452effa6562d'"
          :path="'/pages/universalMarketing/index.html'"
          @launch="infoClick(9)"
        >
        <script type="text/wxtag-template">
          <style>
            .xcx{
              width:205px;
              height:45px;
            }
          </style>
          <div class="xcx" style="width:205px;height:45px;"></div>
        </script>
        </wx-open-launch-weapp>
      </div>
    </div>
    <BaseBtnHome/>
  </div>
</template>
<script>
// import { MessageBox, Indicator } from "mint-ui";
// import Vue from "vue/dist/vue.js";
export default {
  components: {
  },
  data() {
    return {
      projectList:[],
      signInfo:[],
      sign_list:[],
      
      areaId: null,
      signInfoList: [
      ],
      chooseSignInfoList: [],
      // signInfo: {},
      signList: [],
      chooseNavIndex: 0,
      signNavList: [
      ],
      chooseSignNavList: [],

      
      chooseAddressIndex:0,
      addressList: [],
      buildList: [], // 项目展示列表
      chooseBuild: {}, // 选中地区
      chooseBuildList: [
      ], // 选中地区项目列表
    };
  },
  
  async created() {
    this.addressList=this.$config.addressList
    this.areaId = this.$infoId
    await this.chooseAddress( this.$infoId)
  },
  async mounted() {
  },
  methods: {
    // 页面埋点
    infoClick(sceneKey) {
      this.$httpdf.get(this.apiHost + 'info/click', { sceneKey: sceneKey })
    },
    chooseAddress(infoId) {
      let chooseAddressIndex=0;
      chooseAddressIndex=this.addressList.findIndex(v => v.areaId.includes(parseInt(infoId)))
      this.chooseAddressIndex=chooseAddressIndex;
      this.chooseBuildList=this.$config.projectList[chooseAddressIndex].intro
    },
  }
};
</script>
<style lang="scss" scoped>
div{
  position: relative;
}
.bg {
  padding-bottom:80px;
  background: linear-gradient(0deg, #FCC229 0%, #FDD142 49%, #FDD94F 100%);
  // 右侧导航
  .bgImg{
    position: absolute;
    z-index:0;
    width: 343px;
    background-image: url( $imgHost + 'bg.png?v=' + $OSSVersion);
    background-position: top center;
    background-size: 100% auto;
    border: 1px solid #231815;
    border-radius: 0px 0px 62px 0px;
    top:51px;
    bottom:40px;
  }
  // 人数
  .person-number {
    margin-top: 4px;
    display: flex;
    justify-content: space-between;
    padding: 0 17px;
    width: 341px;
    position: relative;
    z-index: 2;
    .number-box {
      width: 110px;
      height: 18px;
      @extend .flex-center-center;
      color: rgba(255, 255, 255, 1);
      font-size: 12px;
      background: rgba(0, 0, 0, .5);
      border-radius: 9px;
      text-align: center;
      span {
        &+span {
          margin-left: 5px;
        }
      }
    }
  }
  .index_btn {
    position: relative;
    width: 375px;
    height: 194px;
    &::after {
      display: block;
      content: '';
      width: 40px;
      height: 45px;
      background: url( $imgHost + 'arrow.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
      position: absolute;
      animation: twinkle 1s infinite linear;
    }
    &.btn1{
      margin-top: 12px;
      background: url( $imgHost + 'index_btn1.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
      &::after {
        top:106px;
        left:178px
      }
    }
    &.btn2{
      background: url( $imgHost + 'index_btn2.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
      &::after {
        top:106px;
        left:301px
      }
    }
    &.btn3{
      background: url( $imgHost + 'index_btn3.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
      &::after {
        top:106px;
        left:186px
      }
    }
  }
  // 活动倒计时
  .endTime {
    margin-top: -9px;
    width: 326px;
    height: 101px;
    background: url( $imgHost + 'time_bg.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #010101;
    position: relative;
    z-index: 2;
    text-align: center;
    padding:29px 55px 20px 127px;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    span {
      display: inline-block;
      font-size: 24px;
      font-weight: bold;
    }
    label {
      display: block;
    }
    div{
      width: 40px;
      height: 3px;
      background: #231815;
      border-radius: 2px;
      margin: auto;
    }
  }
  //我要推荐 一折抢购
  .btn-layer {
    position: fixed;
    bottom: 35px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-around;
    z-index: 99;
    .btn {
      width: 205px;
      height: 45px;
      background: url( $imgHost + 'share_btn.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
    }
  }

  
  .pro-box {
    width: 322px;
    .nav {
      position: relative;
      width: 97px;
      height: 31px;
      background: url( $imgHost + 'nav.png?v=' + $OSSVersion)0 0 / 100% no-repeat;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #231815;
      @extend .flex-center-center;
      margin-left:13px;
      margin-bottom:14px;
      &:nth-child(1) {
        margin-left:0;
      }
      &.choose {
        font-weight: bold;
        color: #FFFFFF;
        background-image: url( $imgHost + 'nav_choose.png?v=' + $OSSVersion) ;
        background-position: top center;
        background-size: 100% auto;
        &::after {
          background: linear-gradient(-90deg, #F7C17A 0%, rgba(247,193,122,0) 100%);
        }
      }
    }
    .pro-nav {
      margin-top:22px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .nav {
        position: relative;
        width: 97px;
        height: 31px;
        background: url( $imgHost + 'nav.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #231815;
        @extend .flex-center-center;
        margin-left:13px;
        margin-bottom:14px;
        &:nth-child(1),&:nth-child(4) {
          margin-left:0;
        }
        &.choose {
          font-weight: bold;
          color: #FFFFFF;
          background: url( $imgHost + 'nav_choose.png?v=' + $OSSVersion)0 0 / 100% no-repeat;
          &::after {
            background: linear-gradient(-90deg, #F7C17A 0%, rgba(247,193,122,0) 100%);
          }
        }
      }
    }
    .welfare{
      position: relative;
      z-index: 2;
      margin-top:29px;
      background: #F6D662;
      border: 1px solid #201715;
      border-radius: 6px;
      &+.welfare {
        margin-top: 50px;
      }
      .project_title{
        width: 314px;
        height:46px;
        margin-top:-27px;
        padding-left:153px;
        text-align: center;
        line-height: 30px;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #201715;
        background: url( $imgHost + 'wlfare/title.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
      }
      .welfare_item{
        width: 299px;
        background: rgba(254, 252, 229, 1);
        border: 1px solid #201715;
        border-radius: 6px;
        padding:25px 25px 14px 25px;
        margin:22px auto;
        &+.welfare_item{
          margin-top:32px;
        }
        .name{
          position: absolute;
          top:-24px;
          left:0;
          width:162px;
        }
        .title{
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          font-style: italic;
          color: #DA6734;
          &::after {
            display: block;
            content: '';
            width: 6px;
            height: 6px;
            background: #DD9139;
            border: 1px solid #201715;
            position: absolute;
            top:4px;
            left:-16px;
          }
        }
        .info{
          margin-top:8px;
          font-size: 12px;
          font-family: Alibaba PuHuiTi;
          font-weight: 400;
          color: #201715;
        }
        &:last-child{
          padding-right:58px;
        }
      }

      .prize{
        position: absolute;
        bottom:-10px;
        right:-28px;
        width:84px;
        z-index:1;
      }
    }
    //.pro-card {
    //  .pro-item {
    //    position: relative;
    //    z-index: 2;
    //    width: 322px;
    //    height:188px;
    //    background: url( $imgHost + 'project_bg.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
    //    .pro-title{
    //      width:100%;
    //      height: 32px;
    //      line-height: 32px;
    //      text-align: center;
    //      font-size: 15px;
    //      font-family: Source Han Sans CN;
    //      font-weight: bold;
    //      color: #231815;
    //    }
    //    &+.pro-item {
    //      margin-top: 24px;
    //    }
    //    &.big {
    //      &+.pro-item {
    //        margin-top: 16px;
    //      }
    //    }
    //    &.big2 {
    //      &+.pro-item {
    //        margin-top: 19px;
    //      }
    //    }
    //    .pro-main{
    //      padding-left:10px;
    //      padding-right:22px;
    //      margin-top:7px;
    //      @extend .flex-center-center;
    //    }
    //    .pro-l {
    //      width: 112px;
    //      img {
    //        width: 100%;
    //      }
    //    }
    //    .pro-r {
    //      margin-left: 12px;
    //      flex: 1;
    //      .pro_txt {
    //        font-size: 14px;
    //        font-family: Source Han Sans CN;
    //        font-weight: 400;
    //        color: #231815;
    //        line-height: 16px;
    //        text-align: center;
    //      }
    //      &.small {
    //        .pro_txt{
    //          font-size: 12px;
    //          text-align: left;
    //        }
    //      }
    //      &.big {
    //        .pro_txt {
    //          margin-top: 10px;
    //        }
    //      }
    //    }
    //    .pro-btn {
    //      margin-top: 10px;
    //      @extend .flex-center-center;
    //      // align-items: flex-start;
    //      justify-content: flex-start;
    //      div {
    //        position: relative;
    //        width: 78px;
    //        height: 24px;
    //        background: #FFFFFF;
    //        border: 1px solid #231815;
    //        border-radius: 12px;
    //        // margin: 0 auto;
    //        font-size: 12px;
    //        font-family: Source Han Sans CN;
    //        font-weight: 400;
    //        color: #231815;
    //        line-height: 16px;
    //        @extend .flex-center-center;
    //        &+div {
    //          margin-left: 10px;
    //        }
    //        .project-xcx {
    //          opacity: 0;
    //          position: absolute;
    //          top: 0;
    //          bottom: 0;
    //          left: 0;
    //          right: 0;
    //          z-index: 3;
    //        }
    //      }
    //    }
    //  }
    // }
  }
  .share{
    position: fixed;
    bottom: 35px;
    left: 85px;
    height:45px;
    display: flex;
    justify-content: space-around;
    z-index: 99;
    width:205px;
    .xcx{
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: #aaa;
      opacity: 0;
      overflow: hidden;
    }
  }

  
  .code-box {
    margin-top: 24px;
    margin-bottom: 80px;
    width: 322px;
    height: 263px;
    background: url( $imgHost + 'code_bg.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
    .code-wrap {
      margin: 51px 82px 0 60px;
      width: 180px;
      height: 180px;
      border-radius: 10px;
      padding: 2px;
      background: #FFFFFF;
      border: 2px solid #EE5D20;
      border-radius: 6px;
      .code {
        width: 100%;
        height: 100%;
        img {
          border-radius: 9px;
        }
      }
    }
  }
}
</style>
